/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Filterprogressstatus_None4Inputs */

const nl_enums_filterprogressstatus_none4 = /** @type {(inputs: Enums_Filterprogressstatus_None4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbehandeld`)
};

/**

* @param {Enums_Filterprogressstatus_None4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_filterprogressstatus_none4 = /** @type {((inputs?: Enums_Filterprogressstatus_None4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Filterprogressstatus_None4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_filterprogressstatus_none4(inputs)
});
export { enums_filterprogressstatus_none4 as "enums.FilterProgressStatus.None" }